import React from 'react'
import Tooltip from 'components/tooltips/Tooltip'

type Props = Record<string, never>

const DeckGameInfo: React.FC<Props> = () => {
  return (
    <Tooltip
      content={
        <div>
          <p>
            This represents the intended <b>game</b> type of a deck (Paper, MTGO or Arena).
          </p>
          <p>
            Currently this only effects the collection flags for the owner of the deck. If you own the deck and set the
            game type, on the cards in the deck and in search, you will only see collection flags from the collection of
            the set game type. (ie: If you set the game type to Paper, you will only see collection flags from your
            paper collection).
          </p>
          <p>
            <b>This change requires a page refresh to take effect on the collection flags.</b>
          </p>
        </div>
      }
    />
  )
}

export default DeckGameInfo
